import { localstorage } from '../local.keys';
import { memorystorage } from '../memory.keys';
import { sessionstorage } from '../session.keys';
import { StorageHelper } from './storage.abstract';

class LocalImpl extends StorageHelper<localstorage> {
  protected set_item(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }
  protected get_item(key: string) {
    return JSON.parse(localStorage.getItem(key) as string);
  }
  protected remove_item(key: string): void {
    localStorage.removeItem(key);
  }
  protected clear_all(): void {
    localStorage.clear();
  }
}
class SessionImpl extends StorageHelper<sessionstorage> {
  protected set_item(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  protected get_item(key: string) {
    return JSON.parse(sessionStorage.getItem(key) as string);
  }
  protected remove_item(key: string): void {
    sessionStorage.removeItem(key);
  }
  protected clear_all(): void {
    sessionStorage.clear();
  }
}

class MemoryImpl extends StorageHelper<memorystorage> {
  private srg = {} as any;
  protected set_item(key: string, value: any): void {
    this.srg[key] = value;
  }
  protected get_item(key: string) {
    const value = this.srg[key];
    if (Array.isArray(value)) {
      return [...value];
    }
    if (value instanceof Object) {
      return { ...value };
    }
    return value;
  }
  protected remove_item(key: string): void {
    delete this.srg[key];
  }
  protected clear_all(): void {
    this.srg = {};
  }
}
class StorageHelperImpl {
  local = new LocalImpl();
  session = new SessionImpl();
  memory = new MemoryImpl();
}
export const storageHelper = new StorageHelperImpl();
